import styled from 'styled-components'
import { HeaderLogo } from '@/features/shared/components/Headers/HeaderLogo'
import { VDivider } from '@/features/shared/components/Dividers'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { useUserStoreName } from '@/features/account/services/User/hooks'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { NextLink } from '@/features/shared/elements/Link'
import { spacing } from '@/features/shared/theme/tokens'
import { routes, getRetailerUrl } from '@shared/constants/routes'
import { Row, Stack } from '@shipt/design-system-layouts'
import { useSearchQueryParams } from '@/features/shared/hooks/search'
import { screenSizes } from '@shipt/design-system-themes'
import { BusinessBadge } from '@/features/business/components/BusinessBadge'

type Props = {
  renderPlaPopover?: () => React.ReactNode
  logo?: string
  color?: string
}

export const LogoAndStoreNav = ({ renderPlaPopover, logo, color }: Props) => {
  const storeName = useUserStoreName()
  const { referrer } = useSearchQueryParams()

  const handleOnClick = () => {
    if (referrer === 'globalSearch') {
      trackElementClicked({ type: 'link', link_name: 'retailer_icon' })
    }
  }

  return (
    <Row align="center" spacing="sm">
      <StoreLogoLink href={routes.GLOBAL_HOMEPAGE.url} aria-label="Global home page link">
        <HeaderLogo />
      </StoreLogoLink>
      <BusinessBadge />
      <DividerStoreLogoRow display={{ sm: 'flex', md: 'none' }} align="center">
        <Divider />
        <div>
          <NextLink
            href={getRetailerUrl(storeName)}
            aria-label={`${storeName} home page. Click to navigate to store home page.`}
            onClick={handleOnClick}
          >
            <StoreImageWrapper backgroundColor={color ?? ''}>
              {!!logo && <StoreImage alt={storeName} src={logo} width={36} height={36} />}
            </StoreImageWrapper>
          </NextLink>
          {renderPlaPopover?.()}
        </div>
      </DividerStoreLogoRow>
    </Row>
  )
}

const Divider = styled(VDivider)`
  height: 1.5rem;
  width: 0.0625rem;
  margin: ${spacing(0, 'sm')};
`

const StoreImageWrapper = styled(Stack)<{
  backgroundColor: string
}>`
  border-radius: 8px;
  border: 1px solid rgb(0 0 0 / 10%);
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 2.75rem;
  height: 2.75rem;
`

const StoreImage = styled(Image)`
  display: block;
  border-radius: 100%;
  height: 100%;
  width: 100%;
  object-fit: contain;
`

const StoreLogoLink = styled(NextLink)`
  display: flex;

  & svg {
    @media ${screenSizes.max_mobile} {
      height: 1.5rem;
      width: auto;
    }
  }
`

const DividerStoreLogoRow = styled(Row)`
  @media ${screenSizes.max_smMobile} {
    display: flex;
  }
`
